export default __webpack_public_path__ + "static/placeholder_bg2-c653e31d2b39face3542da35fec60c1d.jpg";